export class uomIdRequest{
    uomId:number
}